import {
  ModusWcButton,
  ModusWcTypography,
} from '@trimble-oss/moduswebcomponents-react';
import { useTranslation } from 'react-i18next';

export const SignInComponent = ({
  onButtonClick,
}: {
  onButtonClick: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <div className='h-[100dvh] w-[100dvw] flex flex-col gap-8 items-center justify-center'>
      <ModusWcTypography hierarchy='h1'>
        {t('signInComponent.title')}
      </ModusWcTypography>
      <div>
        <ModusWcButton color='primary' onClick={onButtonClick}>
          {t('signInComponent.buttonTitle')}
        </ModusWcButton>
      </div>
    </div>
  );
};
